import { createFileRoute } from "@tanstack/react-router";
import { MachineryInspectionReportsPage } from "@dmca/frontend/widgets/admin/machinery";
import { checkPermissionsInLoader } from "@dmca/frontend/hooks";
import { DateTime, DateZone } from "@dmca/utils/luxon";
import { object, optional, picklist, string } from "valibot";

const getDefaultReportDate = () =>
  DateTime.now()
    .setZone(DateZone.instance) as DateTime<true>;

const parseSearchDate = (date?: string) => {
  const parsed = date
    ? DateTime.fromISO(date, { zone: DateZone.instance })
    : getDefaultReportDate();
  return (parsed.isValid ? parsed : getDefaultReportDate()).setZone(
    DateZone.instance
  ) as DateTime<true>;
};

const getReportTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || DateZone.instance.name;

export const Route = createFileRoute("/_authed/machinery/inspection-reports")({
  validateSearch: object({
    type: optional(picklist(["crane", "forklift"] as const)),
    date: optional(string()),
  }),

  loaderDeps: ({ search }) => ({ type: search.type, date: search.date }),
  component: RouteComponent,
  loader: async ({ context, deps }) => {
    await checkPermissionsInLoader("Machinery::ViewFeature", context);
    const { trpcQcProxy: trpc, qc } = context;
    await qc.prefetchQuery(
      trpc.machinery.getInspectionReports.queryOptions({
        type: deps.type ?? "forklift",
        date: parseSearchDate(deps.date).toISODate()!,
        timeZone: getReportTimeZone(),
      })
    );
  },
  head: () => ({
    meta: [{ title: "Inspection Reports | DNA Dashboard" }],
  }),
});

function RouteComponent() {
  const { type, date } = Route.useSearch();
  const navigate = Route.useNavigate();
  const activeDate = parseSearchDate(date);

  return (
    <MachineryInspectionReportsPage
      type={type}
      date={activeDate}
      onTypeChange={(val) =>
        navigate({ search: { type: val, date: activeDate.toISODate() } })
      }
      onDateChange={(val) =>
        navigate({
          search: { type: type ?? "forklift", date: val.toISODate() },
        })
      }
    />
  );
}
